import { ProfileInfoFieldType } from '../../../Widget'
import { getUserProfileSalutationOptionsData } from '../UserProfileWidget.api'
import {
  USER_PROFILE_INFO_EMAIL_FIELD_NAME,
  USER_PROFILE_INFO_FIRST_NAME_FIELD_NAME,
  USER_PROFILE_INFO_FULL_NAME_FIELD_NAME,
  USER_PROFILE_INFO_LAST_NAME_FIELD_NAME,
  USER_PROFILE_INFO_MIDDLE_NAME_FIELD_NAME,
  USER_PROFILE_INFO_PHONE_FIELD_NAME,
  USER_PROFILE_INFO_SALUTATION_FIELD_NAME,
  USER_PROFILE_INFO_TITLE_FIELD_NAME,
} from '../UserProfileWidget.constants'

export const PARTNER_INFO_FIELDS = [
  {
    getOptionsData: getUserProfileSalutationOptionsData,
    labelKey: 'Widget.InfoPartnerSalutationLabelKey',
    name: USER_PROFILE_INFO_SALUTATION_FIELD_NAME,
    optionLabelKey: 'salutation',
    placeholderKey: 'Widget.InfoPartnerSalutationPlaceholderKey',
    type: ProfileInfoFieldType.SELECT,
  },
  {
    labelKey: 'Widget.InfoPartnerPersonalTitleLabelKey',
    maxLength: 100,
    name: USER_PROFILE_INFO_TITLE_FIELD_NAME,
    placeholderKey: 'Widget.InfoPartnerPersonalTitlePlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoPartnerFirstNameLabelKey',
    maxLength: 100,
    name: USER_PROFILE_INFO_FIRST_NAME_FIELD_NAME,
    placeholderKey: 'Widget.InfoPartnerFirstNamePlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoPartnerMiddleNameLabelKey',
    maxLength: 100,
    name: USER_PROFILE_INFO_MIDDLE_NAME_FIELD_NAME,
    placeholderKey: 'Widget.InfoPartnerMiddleNamePlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoPartnerSecondNameLabelKey',
    maxLength: 100,
    name: USER_PROFILE_INFO_LAST_NAME_FIELD_NAME,
    placeholderKey: 'Widget.InfoPartnerSecondNamePlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoPartnerFullNameLabelKey',
    maxLength: 256,
    name: USER_PROFILE_INFO_FULL_NAME_FIELD_NAME,
    placeholderKey: 'Widget.InfoPartnerFullNamePlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoPartnerEmailLabelKey',
    maxLength: 256,
    name: USER_PROFILE_INFO_EMAIL_FIELD_NAME,
    placeholderKey: 'Widget.InfoPartnerEmailPlaceholderKey',
    type: ProfileInfoFieldType.EMAIL,
  },
  {
    labelKey: 'Widget.InfoPartnerPhoneLabelKey',
    maxLength: 32,
    name: USER_PROFILE_INFO_PHONE_FIELD_NAME,
    placeholderKey: 'Widget.InfoPartnerPhonePlaceholderKey',
    type: ProfileInfoFieldType.PHONE,
  },
]
